export default __webpack_public_path__ + "static/media/172-st-lucia.7c480e49.svg";